<template>
  <div v-if="booking.status.status === 'DROPPED'">
    <v-row no-gutters>
      <v-col align="start" class="info--text">
        Driver {{ booking.driver.firstName + ' ' + booking.driver.lastName }}
      </v-col>
      <v-col align="end" class="info--text">
        Booking <span style="font-size: medium;" class="primary--text">#{{ booking.orderNumber.number }}</span>
      </v-col>
    </v-row>
    <v-row :style="$vuetify.breakpoint.smAndDown ? 'display: block' : '' " class="main--text">
      <v-col>
        <h3>Service type</h3>
        {{ booking.vehicle.name }}
      </v-col>
      <v-col>
        <h3>Waste type</h3>
        {{ booking.waste.name }}
      </v-col>
      <v-col>
        <h3>Instruction</h3>
        {{ booking.instructions }}
      </v-col>
    </v-row>

    <v-row v-if="this.isNull">
      <v-col xs="16" sm="16" md="3">
        <v-text-field
        type="number"
        label="Postal Code"
        v-model="postCode"
        @change="checkCode"
        >
        </v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <h3 class="my-2">Request exchange or collection</h3>
        <p> Select preferred date and time </p>
      </v-col>
    </v-row>
    <v-row>
       <v-col md="3">
        <v-menu
            ref="datePicker"
            v-model="datePicker"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                filled
                v-model="dateFormatted"
                label="Date"
                persistent-hint
                prepend-inner-icon="mdi-calendar"
                v-bind="attrs"
                @blur="date = parseDate(dateFormatted)"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="date"
              no-title
              :min="minDate"
              @input="datePicker = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col md="3">
        <v-select
            filled
            prepend-inner-icon="mdi-clock"
            label="Time"
            :items="preferredTimes"
            v-model="preferredTime"
        ></v-select>
      </v-col>
    </v-row>
    <v-row class="mt-n4">
      <v-col md="6"> 
        <v-textarea
          filled
          height="100"
          label="Special instructions"
          hint="Instructions for the driver"
          v-model="instructions"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col>
        <v-btn
        block
        rounded
        height="50"
        class="primary" 
        v-on:click="exchange()"
        > 
        Exchange </v-btn>
      </v-col>
      <v-col>
        <v-btn
        block
        rounded
        height="50"
        class="primary" 
        v-on:click="collect()"
        > 
        Collection </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  name: 'DroppedBin',
  props: {
    booking: Object
  },
  data(){
    return{
      timeStamp: new Date(),
      minDate: new Date().toISOString().substr(0, 10),
      preferredTime: undefined,
      instructions: '',
      preferredTimes: [ 'AM', 'PM' ],
      date: undefined,
      dateFormatted: undefined,
      datePicker: false,
      price: '',
      isNull: false,
      postCode: ''
    }
  },
  computed: {
    bookingError() {
      return this.$store.getters.getBookingError;
    },
    bookingLength(){
      return this.$store.getters.getBookingLength +1;
    },
    orderNumber(){
      return parseInt(this.$store.getters.getOrderNumber);
    },
    orderId(){
      return parseInt(this.$store.getters.getOrderId);
    },
    wasteTypes() {
      return this.$store.getters.getWasteTypes;
    },
    userCard() {
      let cardId = this.booking.customer.card ? this.booking.customer.card.registrationId : 
      this.$store.getters['auth/getUser'].card ? this.$store.getters['auth/getUser'].card.registrationId : ''; 
      return cardId;
    }
  },
  watch:{
    bookingError(error) {
      if (error) {
        alert(error.message);
        this.$router.go();
      }
    },
    date(){
      this.dateFormatted = this.formatDate(this.date)
    }
  },
  methods: {
    formatDate(date){
      if (!date) return null

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`
    },
    parseDate(date){
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    checkCode(){
      if(this.isNull && (this.postCode == '' || !this.postCode || this.postCode.length != 4)){
        alert('Please enter correct postal code');
        return;
      }
      else if(this.isNull && this.postCode.length == 4){
        let pCode= Number.parseInt(this.postCode)
        this.$store.dispatch('fetchWasteTypesByArea', pCode);
      }
    },
    async collect(){
      if (confirm('Confirm collection request?')){
        if (!this.date || !this.preferredTime){
          alert("Please select a preferred date and time for Collection")
          return null;
        }
        else{
          const collection = Object.assign({}, this.booking);
          collection.arrival = '';
          collection.status = {
            type: 'COLLECTION',
            status: 'SCHEDULING'
          };
          collection.timeStamp = this.timeStamp;
          collection.preferredTime = this.preferredTime;
          collection.preferredDate = this.date;
          collection.instructions = this.instructions;
          delete collection.id;
          if(this.userCard != '' && this.userCard){
            alert("yessss")
            collection.customer = {
              ...collection.customer,
              card: {
                registrationId: this.userCard
              }
            };
          }

          await this.$store.dispatch('createBooking', collection);
          this.$store.dispatch('updateBooking', {
            ...this.booking,
            status:{
              origin: 'DELIVERY'
            }
          });
        }
      }
    },
    async exchange(){
      //check waste type and service type, then assign price accordingly
      this.checkCode();
      this.wasteTypes.forEach((w) => {
          if (w.name == this.booking.waste.name){
            w.vehicles.forEach((v) => {
              if (v.name == this.booking.vehicle.name){
                this.price = v.cost;
              }
            })
          }
        })
        if (confirm('Confirm exchange request?')){
          if(!this.date || !this.preferredTime){
            alert('Please select a preferred date and time for Exchange');
          }
          else{
            const exchange = Object.assign({}, this.booking);
            delete exchange.id;
            delete exchange.arrival;
            delete exchange.serviceNote;
            exchange.parentBookingId = this.booking.id;

            if(this.userCard != '' && this.userCard){
              exchange.customer = {
                ...exchange.customer,
                card: {
                  registrationId: this.userCard
                }
              }
            }

            await this.$store.dispatch('createBooking', {
              ...exchange,
              parentBookingId: this.booking.id,
              status: { type: 'EXCHANGE', status: 'SCHEDULING'},
              timeStamp: this.timeStamp,
              preferredTime: this.preferredTime,
              preferredDate: this.date,
              instructions: this.instructions,
              cost:{
                value: this.price != '' ? this.price : this.booking.cost.value,
                currency: 'ZAR',
                symbol: 'R'
              }
            });
            this.$store.dispatch('updateBooking', {
              ...this.booking,
              status: {
                ...this.booking.status,
                locked: true
              }
            });
          } 
        }
      
    }
  },
  mounted(){
    //get address code and fetch wasteType Area with it, to later update the price
    let address = this.booking.capturedAddress.split(', South Africa').join('');
    let code = address.substr(-4);
    const postalCode = Number.parseInt(this.booking.postCode ? this.booking.postCode : code);
    if(!postalCode){
      this.isNull = true;
    }
    else{
      this.$store.dispatch('fetchWasteTypesByArea', postalCode);
    }
  }
}
</script>
<style scoped>
span{
  font-size: 50px;
}
</style>